// KYC Status Enum (values returned by list API)
export enum UserMeyRealKycStatusEnum {
  DOCUMENTS_REQUESTED = 0,
  PENDING = 1,
  AWAITING_SERVICE = 2,
  REQUIRES_ACTION = 3,
  AWAITING_USER = 4,
  APPROVED = 5,
  REJECTED = 6,
  RESUBMISSION_REQUESTED = 7,
}

// User Status Enum
export enum UserMeyRealStatusEnum {
  ACTIVE = 1,
  BLOCKED = 2,
}

// KYC Status Map (grouped by backend KYC status mapping)
export const USER_MEY_REAL_KYC_STATUS_MAP: Record<number, { label: string; color: string }> = {
  [UserMeyRealKycStatusEnum.DOCUMENTS_REQUESTED]: {
    label: 'Pending',
    color: 'processing',
  },
  [UserMeyRealKycStatusEnum.PENDING]: {
    label: 'Pending',
    color: 'processing',
  },
  [UserMeyRealKycStatusEnum.AWAITING_SERVICE]: {
    label: 'Pending',
    color: 'processing',
  },
  [UserMeyRealKycStatusEnum.REQUIRES_ACTION]: {
    label: 'Pending',
    color: 'processing',
  },
  [UserMeyRealKycStatusEnum.AWAITING_USER]: {
    label: 'Pending',
    color: 'processing',
  },
  [UserMeyRealKycStatusEnum.APPROVED]: {
    label: 'Verified',
    color: 'success',
  },
  [UserMeyRealKycStatusEnum.REJECTED]: {
    label: 'Rejected',
    color: 'error',
  },
  [UserMeyRealKycStatusEnum.RESUBMISSION_REQUESTED]: {
    label: 'Rejected',
    color: 'error',
  },
}

// User Status Map
export const USER_MEY_REAL_STATUS_MAP: Record<number, { label: string; color: string }> = {
  [UserMeyRealStatusEnum.ACTIVE]: {
    label: 'Active',
    color: 'success',
  },
  [UserMeyRealStatusEnum.BLOCKED]: {
    label: 'Blocked',
    color: 'error',
  },
}

// Onchain Identity deploy status (onchainIdentity.status of GET /admin/mey-real-account)
export enum UserOnchainIdentityStatusEnum {
  /** cron created from APPROVED kyc_info, nothing sent on-chain yet */
  PENDING = 0,
  /** IdFactory.createIdentity sent, waiting for the hook to confirm */
  DEPLOY_SUBMITTED = 1,
  /** terminal - identity deployed & confirmed by the hook */
  COMPLETED = 4,
  /** terminal - deterministic error (see failReason), cron will not retry */
  FAILED = 5,
}

export const USER_ONCHAIN_IDENTITY_STATUS_MAP: Record<number, { label: string; color: string }> = {
  [UserOnchainIdentityStatusEnum.PENDING]: {
    label: 'Pending',
    color: 'default',
  },
  [UserOnchainIdentityStatusEnum.DEPLOY_SUBMITTED]: {
    label: 'Deploying',
    color: 'processing',
  },
  [UserOnchainIdentityStatusEnum.COMPLETED]: {
    label: 'Deployed',
    color: 'success',
  },
  [UserOnchainIdentityStatusEnum.FAILED]: {
    label: 'Failed',
    color: 'error',
  },
}

// KYC Filter Status Enum (used for API filter params)
export enum UserMeyRealKycFilterStatusEnum {
  NOT_SUBMITTED = 1,
  PENDING = 2,
  VERIFIED = 3,
  REJECTED = 4,
}

// KYC Status Options for Select (filter)
export const USER_MEY_REAL_KYC_STATUS_OPTIONS = [
  { value: null, label: 'All KYC Status' },
  { value: UserMeyRealKycFilterStatusEnum.NOT_SUBMITTED, label: 'Not Submitted' },
  { value: UserMeyRealKycFilterStatusEnum.PENDING, label: 'Pending' },
  { value: UserMeyRealKycFilterStatusEnum.VERIFIED, label: 'Verified' },
  { value: UserMeyRealKycFilterStatusEnum.REJECTED, label: 'Rejected' },
]

// User Status Options for Select
export const USER_MEY_REAL_STATUS_OPTIONS = [
  { value: null, label: 'All Status' },
  { value: UserMeyRealStatusEnum.ACTIVE, label: 'Active' },
  { value: UserMeyRealStatusEnum.BLOCKED, label: 'Blocked' },
]
